import { motion } from "framer-motion";
import { ShieldCheck, MessageSquareText, Crosshair, FileText } from "lucide-react";
import { Reveal, Label } from "./Reveal";

const CELLS = [
  { icon: ShieldCheck, title: "Nothing invented.", text: "If a claim is inflated or can't be backed up, it goes. Your resume should survive the interview.", span: "md:col-span-2 md:row-span-2", big: true },
  { icon: MessageSquareText, title: "We ask. You confirm.", text: "Every number comes from you, not from guesswork.", span: "md:col-span-2" },
  { icon: Crosshair, title: "Aimed at your target.", text: "Keywords drawn from the jobs you're applying for.", span: "" },
  { icon: FileText, title: "Word + PDF.", text: "Clean files, ready to send.", span: "" },
];

export const Rules = () => (
  <section className="mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-36" data-testid="rules-section">
    <Reveal>
      <Label>The rules we work by</Label>
      <h2 className="font-serif-d mt-5 max-w-3xl text-5xl leading-[0.95] text-white sm:text-6xl">
        Strong, <span className="italic text-[var(--teal)]">and true.</span>
      </h2>
    </Reveal>
    <div className="mt-14 grid auto-rows-[minmax(200px,auto)] gap-4 md:grid-cols-4">
      {CELLS.map(({ icon: Icon, title, text, span, big }, i) => (
        <Reveal key={title} delay={i * 0.08} className={span}>
          <motion.div whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 260, damping: 20 }}
            data-testid={`rule-card-${i}`}
            className={`group flex h-full flex-col justify-between rounded-3xl border border-white/10 p-8 transition-colors duration-500 hover:border-[var(--teal)]/50 ${big ? "bg-[var(--teal)] text-[var(--ink)]" : "bg-[var(--navy-2)]"}`}>
            <Icon className={`h-7 w-7 ${big ? "text-[var(--ink)]" : "text-[var(--teal)]"}`} strokeWidth={1.5} />
            <div className="mt-10">
              <h3 className={`font-serif-d leading-none ${big ? "text-5xl sm:text-6xl" : "text-3xl text-white"}`}>{title}</h3>
              <p className={`mt-4 text-base leading-relaxed ${big ? "max-w-sm text-[var(--ink)]/80" : "text-slate-300"}`}>{text}</p>
            </div>
          </motion.div>
        </Reveal>
      ))}
    </div>
  </section>
);
